
import Vue from "vue";
import Component from "vue-class-component";
import RulesUtil from "@/util/rules";
import UsuarioModel from "@/models/usuario.model";
import Service from "@/service/usuario.service";
import {namespace} from 'vuex-class';
import Listas from "@/models/lists/listas.model";

const auth = namespace('auth');

@Component({
  name: "UserProfileView"
})
export default class UserProfileView extends Vue {

  @auth.Getter('id') id;
  @auth.Getter('email') email;

  private rules = RulesUtil;
  private usuario = new UsuarioModel();
  private repetirSenha = '';
  private listaUsuarios: Array<UsuarioModel> = [];
  private page = 0;
  private loading = false;
  private emailDisabled = false;
  private equal: string | boolean = true;
  private listas = new Listas();

  async cadastrar() {
    if ((this.$refs.formUser as HTMLFormElement).validate()) {
      await Service.cadastrar(this.usuario);
      (this.$refs.formUser as HTMLFormElement).reset();
      this.usuario = new UsuarioModel();
      await this.getAll();
    }
  }

  async dadosUp(item: UsuarioModel) {
    this.emailDisabled = true;
    const usuarioSelecionado: UsuarioModel = Object.assign({}, item);
    this.usuario = usuarioSelecionado;
  }

  async atualizar() {
    if ((this.$refs.formUser as HTMLFormElement).validate()) {
      await Service.atualizar(this.usuario);
      (this.$refs.formUser as HTMLFormElement).reset();
      this.usuario = new UsuarioModel();
      await this.getAll();
      this.emailDisabled = false;
    }
  }

  cadastrarOuAtualizar() {
    if (this.emailDisabled) {
      this.atualizar();
    } else {
      this.cadastrar();
    }
  }

  senhaEqual() {
    this.equal = this.repetirSenha !== this.usuario.password
        ? 'Senha diferente!'
        : true;
    return this.repetirSenha !== this.usuario.password
        ? 'Senha diferente!'
        : true;
  }

  async getAll() {
    this.listaUsuarios = await Service.buscarTodos();
  }

  mounted() {
    this.getAll();
  }

}
